import React from 'react'
import { ReactComponent as GiftSvg } from 'resources/svg/icons/gift.svg'
import { ReactComponent as DumbbellSvg } from 'resources/svg/icons/dumbbell.svg'
import { ReactComponent as NightSvg } from 'resources/svg/icons/nightSleep.svg'
import { ReactComponent as DropsSvg } from 'resources/svg/icons/raindrops.svg'
import { ReactComponent as DiscreetSvg } from 'resources/svg/icons/discreet.svg'
import { ReactComponent as DripSvg } from 'resources/svg/icons/drip.svg'
import { ReactComponent as DribbleSvg } from 'resources/svg/icons/dribble.svg'
import { ReactComponent as GushSvg } from 'resources/svg/icons/gush.svg'
import { ReactComponent as HeavySvg } from 'resources/svg/icons/heavy.svg'
import { ReactComponent as FloodSvg } from 'resources/svg/icons/flood.svg'
import { Wrapper, Item } from './components/Styled'

interface Props {
  absorbency: string
  discreet: string
  overnight: string
  innerLegCuff: string
}

export const FeaturedAttributes: React.FC<Props> = ({
  absorbency,
  discreet,
  overnight,
  innerLegCuff
}) => {
  const generalAttribute = !overnight && !discreet && !innerLegCuff

  return (
    <Wrapper>
      <Attribute attribute='satisfaction' />
      {overnight && (
        <Attribute attribute='overnight' />
      )}
      {!overnight && discreet && (
        <Attribute attribute='discreet' />
      )}
      {!overnight && !discreet && innerLegCuff && (
        <Attribute attribute='innerLegCuff' />
      )}
      {generalAttribute && (
        <Attribute attribute='generalAttribute' />
      )}
      {absorbency && (
        <Attribute attribute='absorbency' value={absorbency} />
      )}
    </Wrapper>
  )
}

interface AttributeProps {
  attribute: 'absorbency' | 'primary_bladder_leakage' | 'generalAttribute' | 'overnight' | 'discreet' | 'innerLegCuff' | 'satisfaction' | string
  value?: string
}

export const Attribute = ({ attribute, value }: AttributeProps) => {
  const absorbencyIcon = () => {
    switch (value) {
      case 'Drip':
        return <DripSvg />
      case 'Dribble':
        return <DribbleSvg />
      case 'Gush':
        return <GushSvg />
      case 'Heavy Flow':
        return <HeavySvg />
      case 'Flooding':
        return <FloodSvg />
      default:
        return <DropsSvg />
    }
  }
  switch (attribute) {
    case 'absorbency':
    case 'primary_bladder_leakage':
      return (
        <Item>
          {absorbencyIcon()}
          <span>Great for a {value}</span>
        </Item>
      )

    case 'overnight':
      return (
        <Item>
          <NightSvg />
          <span>Great for a good night's sleep</span>
        </Item>
      )

    case 'innerLegCuff':
      return (
        <Item>
          <DropsSvg />
          <span>Great for protection against leaks</span>
        </Item>
      )

    case 'discreet':
      return (
        <Item>
          <DiscreetSvg />
          <span>Great for a discreet look</span>
        </Item>
      )

    case 'satisfaction':
      return (
        <Item>
          <GiftSvg />
          <span>100% satisfaction guaranteed</span>
        </Item>
      )

    case 'generalAttribute':
      return (
        <Item>
          <DumbbellSvg />
          <span>Great for everyday use</span>
        </Item>
      )

    default:
      return null
  }
}
